// extracted by mini-css-extract-plugin
export default {"boardsOverviewButton":"BoardsOverview_boardsOverviewButton__MdNaM"};